// import { Link } from "react-router-dom"
import { NavBar, Footer, GetReady, Blog, CoursePage, Review, Landing, Whatsapp } from "../../Components/ExportComponents"
import "./Home.css"
import logo from "../../Photos/back.png"
import { Helmet } from "react-helmet";
// import { useEffect, useRef, useState } from "react"
// import { useState, useEffect } from "react";

const Home = ({ fullNav, blogs, CoursesDetails, Reviews }) => {


    return (<>
        <Helmet>
            {/* Geo Tags */}
            <meta name="geo.region" content="NP-GA" />
            <meta name="geo.placename" content="Pokhara" />
            <meta name="geo.position" content="28.2096;83.9856" />
            <meta name="ICBM" content="28.2096, 83.9856" />

            {/* SEO Meta Tags */}
            <title>Scaleup Academy | Best IT & Graphic Design Courses in Pokhara, Nepal</title>
            <meta name="description" content="Learn top IT and design courses at Scaleup Academy, Pokhara." />

            <meta name="author" content="Scaleup Academy" />

            {/* Open Graph / Social Media Tags */}
            <meta property="og:title" content="Scaleup Academy | Best IT & Graphic Design Courses in Pokhara" />
            <meta
                property="og:description"
                content="Join Scaleup Academy, the best IT and graphic design classes in Pokhara. Learn practical skills in web development, programming, AI, and design from expert instructors."
            />
            <meta property="og:image" content="https://scale-upacademy.com/static/media/fullgreen.7b1a9a6d5005f1002ae3.png" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://scale-upacademy.com" />

            {/* Optional: Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Scaleup Academy | Best IT & Graphic Design Courses in Pokhara" />
            <meta
                name="twitter:description"
                content="Scaleup Academy is the top institute in Pokhara for IT, web development, AI, and graphic design courses with hands-on guidance."
            />
            <meta name="twitter:image" content="https://scale-upacademy.com/static/media/fullgreen.7b1a9a6d5005f1002ae3.png" />
        </Helmet>


        <NavBar fullNav={fullNav} />
        <div className="homePage">
            <Whatsapp />

            <Landing />

            {/* Courses  */}
            <CoursePage CoursesDetails={CoursesDetails} />

            <GetReady clean={false} />
            <Blog Blogs={blogs} />
            <GetReady clean={true} logo={true} />
            <Review ReviewC={Reviews} />
            <Footer />


        </div >
    </>)
}
export default Home